import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'
import { localStorageKeys } from '~/adapter/localstorage/keys'

type LanguageStoreState = {
  /** 現在選択中の言語コード (例: 'ja', 'en', 'vi') */
  currentLanguage: string
  /** 翻訳時に原文（日本語）を併記するかどうか */
  showOriginalText: boolean
}

type LanguageStoreAction = {
  /** 言語を変更する */
  setLanguage: (language: string) => void
  /** 原文併記の ON/OFF を切り替える */
  setShowOriginalText: (value: boolean) => void
  /** ログアウト時に言語設定をリセットする */
  logoutLanguage: () => void
}

const initialState: LanguageStoreState = {
  currentLanguage: 'ja',
  showOriginalText: false,
}

export const useLanguageStore = create<
  LanguageStoreState & LanguageStoreAction
>()(
  devtools(
    immer(
      persist(
        set => ({
          ...initialState,
          setLanguage: (language: string) =>
            set(state => {
              state.currentLanguage = language
              if (language === 'ja') {
                state.showOriginalText = initialState.showOriginalText
              }
            }),
          setShowOriginalText: (value: boolean) =>
            set(state => {
              state.showOriginalText = value
            }),
          logoutLanguage: () =>
            set(state => {
              state.currentLanguage = initialState.currentLanguage
              state.showOriginalText = initialState.showOriginalText
            }),
        }),
        {
          name: localStorageKeys.languageStore,
          version: 0,
        },
      ),
    ),
  ),
)

/**
 * 現在の言語を取得する selector
 */
export const selectCurrentLanguage = (state: LanguageStoreState): string => {
  return state.currentLanguage
}

/**
 * 原文併記の設定を取得する selector
 */
export const selectShowOriginalText = (state: LanguageStoreState): boolean => {
  return state.showOriginalText
}
